import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-100 text-foreground-800">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-white">
                <i className="ri-link-m text-base"></i>
              </span>
              <span className="text-lg font-bold text-foreground-950">
                USFans<span className="text-primary-600">Link</span>
              </span>
            </div>
            <p className="mt-3 max-w-sm text-sm text-foreground-600">{t('footer.tagline')}</p>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wide text-foreground-950">
              {t('footer.explore')}
            </h4>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <Link to="/" className="text-foreground-600 transition-colors hover:text-primary-700">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link
                  to="/usfans-spreadsheet-guide"
                  className="text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {t('footer.guide')}
                </Link>
              </li>
              <li>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {t('footer.mainSite')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wide text-foreground-950">
              {t('footer.shop')}
            </h4>
            <ul className="mt-3 grid grid-cols-1 gap-2 text-sm">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.key}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {t(`category.${cat.key}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-secondary-200 pt-6">
          <p className="text-xs leading-relaxed text-foreground-500">{t('footer.disclaimer')}</p>
          <p className="mt-3 text-xs text-foreground-500">
            © {new Date().getFullYear()} USFansLink. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
}